<template>
  <div class="container text-secondary">
    <div class="row mb-3">
      <div class="col-2"/>
      <div class="col text-center">
        <div class="h4">Speel een spel</div>
      </div>
      <div class="col-2 text-end pe-2">
        <img src="@/assets/back-48.png" alt="terug" class="img-fluid"
             style="height:32px; cursor:pointer;" @click="$router.push('/')"/>
      </div>
    </div>

    <hr class="divider">

    <!-- Stap 1: Kies spel -->
    <div class="stap-header">
      <div class="stap-nr">1</div>
      <div class="stap-titel">Kies een spel</div>
    </div>

    <div class="game-kaart mb-2" v-for="spel in spellen" :key="spel.route"
         :class="{ gekozen: gekozenSpel === spel.route }"
         @click="gekozenSpel = spel.route">
      <img :src="spel.icoon" :alt="spel.naam" class="game-icoon"/>
      <div class="game-info">
        <div class="game-naam">{{ spel.naam }}</div>
        <div class="game-desc">{{ spel.desc }}</div>
      </div>
      <span class="check" v-if="gekozenSpel === spel.route">✓</span>
    </div>

    <hr class="divider">

    <!-- Stap 2: Tafel instellen -->
    <div class="stap-header">
      <div class="stap-nr">2</div>
      <div class="stap-titel">Stel de tafel in</div>
    </div>

    <div v-if="players.length === 0" class="leeg-state">
      Geen spelers — <span style="color:#667eea; cursor:pointer;" @click="$router.push('/lounge')">voeg eerst spelers toe</span>
    </div>

    <div v-else class="card-modern">
      <!-- Aan tafel -->
      <div style="font-weight:700; color:#4a5568; margin-bottom:8px;">
        <img src="@/assets/table-100.png" alt="" style="height:24px; margin-right:6px;"/>
        Aan tafel
        <span style="font-size:0.85rem; color:#a0aec0; font-weight:400;">— sleep om volgorde te wijzigen</span>
      </div>

      <div v-if="tafel.length === 0" style="color:#a0aec0; text-align:center; padding:12px;">
        Voeg spelers toe via de lijst hieronder
      </div>

      <draggable
          v-model="tafel"
          item-key="id"
          handle=".drag-handle"
          animation="150"
          @end="slaOp"
      >
        <template #item="{ element, index }">
          <div class="tafel-rij">
            <span class="drag-handle">☰</span>
            <span style="font-size:1.2rem;">{{ element.gender === 'female' ? '👩' : '👨' }}</span>
            <span class="tafel-naam">{{ element.name }}</span>
            <span v-if="index === 0" class="dealer-badge">Eerste deler</span>
            <button class="verwijder-btn" @click="verwijderVanTafel(element.id)">✕</button>
          </div>
        </template>
      </draggable>

      <hr class="divider" v-if="beschikbaar.length > 0"/>

      <!-- Beschikbare spelers -->
      <div v-if="beschikbaar.length > 0">
        <div style="font-weight:700; color:#4a5568; margin-bottom:8px;">
          <img src="@/assets/crowd-100.png" alt="" style="height:24px; margin-right:6px;"/>
          Toevoegen
        </div>
        <div v-for="player in beschikbaar" :key="player.id"
             class="beschikbaar-rij" @click="voegToe(player)">
          <span style="font-size:1.2rem;">{{ player.gender === 'female' ? '👩' : '👨' }}</span>
          <span class="tafel-naam">{{ player.name }}</span>
          <span style="color:#667eea; font-size:1.2rem;">＋</span>
        </div>
      </div>
    </div>

    <hr class="divider">

    <!-- Begin knop -->
    <div class="text-center">
      <button class="btn-primary-modern btn-groot"
              :disabled="!kanBeginnen"
              @click="beginSpel">
        Begin! 🎮
      </button>
      <div v-if="!kanBeginnen" style="font-size:0.85rem; color:#a0aec0; margin-top:8px;">
        {{ !gekozenSpel ? 'Kies eerst een spel' : 'Minimaal 2 spelers aan tafel' }}
      </div>
    </div>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import store from "@/store";

// Importeer iconen als variabelen zodat we ze in data() kunnen gebruiken
import icoonCards from '@/assets/cards-100.png'
import icoonHeart from '@/assets/heart-48.png'
import icoonDice from '@/assets/dice-100.png'
import icoonDarts from '@/assets/darts-100.png'
import icoonKlaverjas from '@/assets/cards-100.png'

export default {
  name: "PlaySreen",
  components: { draggable },
  data() {
    return {
      gekozenSpel: null,
      tafel: [],
      spellen: [
        { route: '/bokkerijen',   naam: 'Bokkerijen',   desc: 'Kaartspel met bieden',               icoon: icoonCards },
        { route: '/hartenjagen',  naam: 'Hartenjagen',  desc: 'Vermijd harten en de schoppendame',  icoon: icoonHeart },
        { route: '/rummikub',     naam: 'Rummikub',     desc: 'Laagste score wint',                 icoon: icoonDice  },
        { route: '/klaverjas',    naam: 'Klaverjassen', desc: 'Met 2, 3 of 4 spelers',              icoon: icoonKlaverjas },
        { route: '/darten',       naam: 'Darten',       desc: '501 of 301, single of dubbel',       icoon: icoonDarts },
      ],
    };
  },
  computed: {
    players() {
      return store.state.players;
    },
    beschikbaar() {
      return this.players.filter(p => !this.tafel.find(t => t.id === p.id));
    },
    kanBeginnen() {
      return this.gekozenSpel !== null && this.tafel.length >= 2;
    },
  },
  created() {
    this.tafel = [...store.state.playersRoom];
  },
  methods: {
    voegToe(player) {
      this.tafel.push(player);
      this.slaOp();
    },
    verwijderVanTafel(id) {
      this.tafel = this.tafel.filter(p => p.id !== id);
      this.slaOp();
    },
    slaOp() {
      store.commit('setPlayersRoom', [...this.tafel]);
    },
    beginSpel() {
      this.slaOp();
      this.$router.push(this.gekozenSpel);
    },
  },
}
</script>

<style scoped>
.stap-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.stap-nr {
  background: #667eea;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.9rem;
  flex-shrink: 0;
}
.stap-titel {
  font-size: 1.1rem;
  font-weight: 800;
  color: #2d3748;
}
.game-kaart {
  display: flex;
  align-items: center;
  gap: 14px;
  background: white;
  border-radius: 14px;
  padding: 12px 16px;
  margin-bottom: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.15s;
}
.game-kaart:hover { border-color: #667eea; background: #f8f9ff; }
.game-kaart.gekozen { border-color: #667eea; background: #ebf4ff; }
.game-icoon { height: 40px; width: 40px; object-fit: contain; }
.game-info { flex: 1; }
.game-naam { font-weight: 700; color: #2d3748; }
.game-desc { font-size: 0.82rem; color: #a0aec0; margin-top: 2px; }
.check { font-size: 1.3rem; color: #667eea; font-weight: 800; }
.tafel-rij {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-radius: 10px;
  margin-bottom: 6px;
  background: #f7fafc;
  border: 2px solid transparent;
  user-select: none;
}
.drag-handle {
  color: #cbd5e0;
  font-size: 1.1rem;
  cursor: grab;
  padding: 0 4px;
  touch-action: none;
}
.drag-handle:active { cursor: grabbing; }
.tafel-naam { flex: 1; font-weight: 600; color: #2d3748; }
.dealer-badge {
  font-size: 0.75rem;
  background: #667eea;
  color: white;
  border-radius: 8px;
  padding: 2px 8px;
  font-weight: 700;
}
.verwijder-btn {
  background: none;
  border: none;
  color: #fc8181;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px 6px;
  border-radius: 6px;
}
.verwijder-btn:hover { background: #fff5f5; }
.beschikbaar-rij {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-radius: 10px;
  margin-bottom: 6px;
  background: #f7fafc;
  cursor: pointer;
  transition: all 0.15s;
}
.beschikbaar-rij:hover { background: #ebf4ff; }
.leeg-state {
  text-align: center;
  color: #a0aec0;
  padding: 20px;
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  margin-bottom: 16px;
}
.btn-groot {
  padding: 14px 40px;
  font-size: 1.1rem;
}
</style>